// Logo Section
export const setProjectLogo = 'setProjectLogo';
export const removeProjectLogo = 'removeProjectLogo';
export const changeProjectImageSize = 'changeProjectImageSize';
export const alignProjectLogo = 'alignProjectLogo';
export const changeLogoBackgroundColor = 'changeLogoBackgroundColor';

// Background Image Section
export const setProjectBackgroundImage = 'setProjectBackgroundImage';
export const setProjectBackgroundImageOpacity = 'setProjectBackgroundImageOpacity';
export const toggleBackgroundImageTiled = 'toggleBackgroundImageTiled';
export const removeBackgroundImage = 'removeBackgroundImage';

// Background color
export const changeBackgroundColor = 'changeBackgroundColor';

// Buttons color
export const changePrimaryColor = 'changePrimaryColor';

// Questions
export const alignQuestionsText = 'alignQuestionsText';
export const changeQuestionColor = 'changeQuestionColor';
export const changeQuestionFont = 'changeQuestionFont';

// Options
export const changeAnswersColor = 'changeAnswersColor';
export const changeAnswersFont = 'changeAnswersFont';

// Load Responses
export const loadResponses = 'loadResponses';
